// extracted by mini-css-extract-plugin
export default {"price":"lha-z","onSale":"mha-z","msrpLabelPrice":"nha-z","msrpLabel":"oha-z","originalPrice":"pha-z"};